import YHtance from "./request";
export const BSsetJobIndex = (params) => YHtance.post("/admin/setJobIndex", params);
export const LPsetJobIndex = (params) => YHtance.post("/admin/setLPJobIndex", params);
export const ZLsetJobIndex = (params) => YHtance.post("/admin/setZLJobIndex", params);
// 获取搜索简历信息
export const GetResumeList = (params) => YHtance.post("/admin/search", params);

// 获取当前简历ID信息
export const GetResumeInfo = (params) => YHtance.post("/admin/getresume", params);

// 修改基础信息
export const updateBaseInfo = (params) => YHtance.post("/admin/upbaseInfo", params);

// 设置时间
export const setTime = (params) => YHtance.post("/admin/setTime", params);
export const getTime = (params) => YHtance.post("/admin/getAllTime", params);
// 获取任务执行日志
export const getLogList = (params) => YHtance.post("/admin/getLogList", params);

// 修改求职信息
export const updatewantJobInfo = (params) => YHtance.post("/admin/upwantJobInfo", params);

// 修改工作经历
export const updateworkInfo = (params) => YHtance.post("/admin/upworkInfo", params);
// 修改教育经历
export const updateeduInfo = (params) => YHtance.post("/admin/upeduInfo", params);
// 修改个人介绍
export const updateMyself = (params) => YHtance.post("/admin/upmyself", params);
// 修改项目经历
export const updateproject = (params) => YHtance.post("/admin/upproject", params);

// 删除工作经历
export const delWorkInfo = (params) => YHtance.post("/admin/DelWorkInfo", params);
// 删除教育经历
export const delEduInfo = (params) => YHtance.post("/admin/DelEduInfo", params);
// 删除项目经历
export const delProjInfo = (params) => YHtance.post("/admin/DelProjectInfo", params);
// 添加工作经历
export const AddWorkInfo = (params) => YHtance.post("/admin/AddWorkInfo", params);
// 添加教育经历
export const AddEduInfo = (params) => YHtance.post("/admin/AddEduInfo", params);
// 添加项目经历
export const AddProjInfo = (params) => YHtance.post("/admin/AddProjectInfo", params);
// 上传简历信息
export const AddResume = (params) => YHtance.post("/admin/uploadResume", params);


// 人岗匹配分析
export const AIjlfx = (params) => YHtance.post("/admin/aijlfx", params);
// AI生成面试题库
export const AImstk = (params) => YHtance.post("/admin/aimstk", params);
// 通过职位名称获取信息
export const jobNameGetAIKnow = (params) => YHtance.post("/admin/jobNameGetAIKnow", params);
// 获取职位列表
export const getLPJobList = (params) => YHtance.post("/admin/getLPJobList", params);
// 获取职位信息
export const getLPJobInfo = (params) => YHtance.post("/admin/getLPJobInfo", params);
// 创建职位信息
export const createLPJob = (params) => YHtance.post("/admin/createLPJob", params);
// 修改职位信息
export const updateLPJob = (params) => YHtance.post("/admin/updateLPJob", params);
// 删除职位信息
export const delectLPJob = (params) => YHtance.post("/admin/delectLPJob", params);
// 获取职位列表
export const getZLJobList = (params) => YHtance.post("/admin/getZLJobList", params);
// 获取职位信息
export const getZLJobInfo = (params) => YHtance.post("/admin/getZLJobInfo", params);
// 创建职位信息
export const createZLJob = (params) => YHtance.post("/admin/createZLJob", params);
// 修改职位信息
export const updateZLJob = (params) => YHtance.post("/admin/updateZLJob", params);
// 删除职位信息
export const delectZLJob = (params) => YHtance.post("/admin/delectZLJob", params);
// 获取职位列表
export const getJobList = (params) => YHtance.post("/admin/getJobList", params);
// 获取职位信息
export const getJobInfo = (params) => YHtance.post("/admin/getJobInfo", params);
// 创建职位信息
export const createJob = (params) => YHtance.post("/admin/createJob", params);
// 修改职位信息
export const updateJob = (params) => YHtance.post("/admin/updateJob", params);
// 删除职位信息
export const delectJob = (params) => YHtance.post("/admin/delectJob", params);
// 获取知识库
export const getKnow = (params) => YHtance.post("/admin/getKnow", params);
// 创建知识库
export const addKnow = (params) => YHtance.post("/admin/addKnow", params);
// 修改知识库
export const updateKnow = (params) => YHtance.post("/admin/upKnow", params);
// 删除知识库
export const delKnow = (params) => YHtance.post("/admin/delKnow", params);
// 获取复聊
export const getAgain = (params) => YHtance.post("/admin/getAgain", params);
// 创建复聊
export const addAgain = (params) => YHtance.post("/admin/addAgain", params);
// 修改复聊
export const updateAgain = (params) => YHtance.post("/admin/upAgain", params);
// 删除复聊
export const delAgain = (params) => YHtance.post("/admin/delAgain", params);

// 获取提问
export const getInterview = (params) => YHtance.post("/admin/getInterview", params);
// 创建提问
export const addInterview = (params) => YHtance.post("/admin/addInterview", params);
// 修改提问
export const upInterview = (params) => YHtance.post("/admin/upInterview", params);
// 删除提问
export const delInterview = (params) => YHtance.post("/admin/delInterview", params);

// 保存已读简历
export const readCache = (params) => YHtance.post("/admin/readCache", params);
// 获取名字拼音
export const getPinyin = (params) => YHtance.post("/admin/getNamePinYin", params);
// 登录Login
export const Login = (params) => YHtance.post("/admin/login", params);
export const updatePSW = (params) => YHtance.post("/admin/updatepsw", params);
export const saveUserInfo = (params) => YHtance.post("/admin/saveUserInfo", params);
export const getUserInfo = (params) => YHtance.post("/admin/getUserInfo", params);
export const addAppraise = (params) => YHtance.post("/admin/addAppraise", params);
export const getAppraise = (params) => YHtance.post("/admin/getAppraise", params);
export const GetComJobsInfo = (params) => YHtance.post("/admin/getComJob", params);

// 登记表配置信息
export const getRegConfig = (params) => YHtance.post("/admin/getRegConfig", params);
export const setRegConfig = (params) => YHtance.post("/admin/setRegConfig", params);
export const saveRegConfig = (params) => YHtance.post("/admin/updateRegConfig", params);

export const getRegSearch = (params) => YHtance.post("/admin/regResSearch", params);

export const setInterviewee = (params) => YHtance.post("/admin/setInterviewee", params);
export const getInterviewee = (params) => YHtance.post("/admin/getInterviewee", params);
export const upInterviewee = (params) => YHtance.post("/admin/upInterviewee", params);
export const delInterviewee = (params) => YHtance.post("/admin/delInterviewee", params);
export const searchInterviewee = (params) => YHtance.post("/admin/searchInterviewee", params);
export const setInterviewInfo = (params) => YHtance.post("/admin/setInterviewInfo", params);
export const getInterviewInfo = (params) => YHtance.post("/admin/getInterviewInfo", params);

// 获取面试登记表信息
export const GetregisterInfo = (params) => YHtance.post("/admin/getregisterInfo", params);

// 设置面试进度
export const setSchedule = (params) => YHtance.post("/admin/setSchedule", params);
// 设置转正分数
export const setFormalScore = (params) => YHtance.post("/admin/setformalScore", params);
// 设置面试评价
export const setAppraises = (params) => YHtance.post("/admin/setAppraises", params);
export const getAppraises = (params) => YHtance.post("/admin/getAppraises", params);

// 地址管理
export const setAddressManage = (params) => YHtance.post("/admin/setregisterAddress", params);
export const getAddressManage = (params) => YHtance.post("/admin/getregisterAddress", params);
export const upAddressManage = (params) => YHtance.post("/admin/upregisterAddress", params);
export const delAddressManage = (params) => YHtance.post("/admin/delregisterAddress", params);

// 我的人才
export const getMyTalent = (params) => YHtance.post("/admin/getMyTalent", params);
export const searchMyTalent = (params) => YHtance.post("/admin/searchMyTalent", params);

// 获取BI数据
export const getMyZPBI = (params) => YHtance.post("/admin/getMyZPBI", params);
export const getTeamZPBI = (params) => YHtance.post("/admin/getTeamZPBI", params);
// 导出PDF
export const exportPDF = (params) => YHtance.post("/admin/exportPDF", params);
export const exportRegisterPDF = (params) => YHtance.post("/admin/exportRegisterPDF", params);

// 职位管理API
export const createResumeJobs = (params) => YHtance.post("/admin/createResumeJobs", params);
export const searchResumeJobs = (params) => YHtance.post("/admin/searchResumeJobs", params);
export const getInterviewJobName = (params) => YHtance.post("/admin/getInterviewJobName", params);
export const closeResumeJobs = (params) => YHtance.post("/admin/closeResumeJobs", params);
export const getResumeJobs = (params) => YHtance.post("/admin/getResumeJobs", params);
export const getResumeJobInfo = (params) => YHtance.post("/admin/getResumeJobInfo", params);
export const updateResumeJobs = (params) => YHtance.post("/admin/upResumeJobs", params);
// 把简历加入职位（前端约定端点，待后端确认路由与字段名）
export const setjobrecom = (params) => YHtance.post("/admin/setjobrecom", params);
export const getjobrecom = (params) => YHtance.post("/admin/getjobrecom", params);
export const getresumeRecom = (params) => YHtance.post("/admin/getresumeRecom", params);
export const getInterRecord = (params) => YHtance.post("/admin/getInterRecord", params);

export const setHijackData = (params) => YHtance.post("/admin/setHijackData", params);
